import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - PCS Energy`;
  }, [title]);
}

export default useTitle;
